import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { config as CONFIG, FORMATO_FECHA } from "app/app.config";
import { UF } from "app/main/apps/shared/interfaces/uf.interface";
import { OrdenCompraDTO } from "app/main/apps/shared/models/orden-compra.model";

@Component({
    selector: "app-dialog-asociar-factura-oocc",
    templateUrl: "./dialog-asociar-factura-oocc.component.html",
    styleUrls: ["./dialog-asociar-factura-oocc.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: MAT_DATE_FORMATS, useValue: FORMATO_FECHA }],
})
export class DialogAsociarFacturaOoccComponent implements OnInit {
    totalFactura: number;
    formFactura: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<DialogAsociarFacturaOoccComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { oocc: OrdenCompraDTO[]; uf: UF },
        private fb: FormBuilder
    ) {}

    async ngOnInit(): Promise<void> {
        //console.log(this.data);

        this.initFormFactura();

        this.formFactura.get("montoBruto").valueChanges.subscribe((val) => {
            this.formFactura
                .get("iva")
                .setValue(Math.round(val * Number(CONFIG.iva)));
        });

        this.calculaTotalFactura();
    }

    initFormFactura() {
        this.formFactura = this.fb.group({
            nroFactura: [
                null,
                { validators: [Validators.required, Validators.maxLength(10)] },
            ],
            fecha: [null, { validators: [Validators.required] }],
            montoBruto: [
                this.totalFactura,
                {
                    validators: [Validators.required, Validators.min(0)],
                },
            ],
            iva: [
                null,
                {
                    validators: [Validators.required, Validators.min(0)],
                },
            ],
        });
    }
    calculaTotalFactura() {
        this.totalFactura = 0;
        this.data.oocc.forEach((oocc) => {
            this.totalFactura += Math.round(
                oocc.valorTotal * this.data.uf.valor
            );
        });
        this.formFactura.get("montoBruto").setValue(this.totalFactura);
    }

    get montoBruto() {
        return this.formFactura.get("montoBruto");
    }

    get nroFactura() {
        return this.formFactura.get("nroFactura");
    }

    get fecha() {
        return this.formFactura.get("fecha");
    }

    get iva() {
        return this.formFactura.get("iva");
    }
}
